module.exports = __webpack_public_path__ + "img/29.1c2f64b3.jpg";